const VolumeDown = () => (
  <>
    <path
      fill="currentColor"
      d="M9.423 14H6.808A.784.784 0 0 1 6 13.192v-2.384A.784.784 0 0 1 6.808 10h2.615l2.685-2.685a.49.49 0 0 1 .568-.116.47.47 0 0 1 .324.476v8.65q0 .348-.324.476a.49.49 0 0 1-.568-.116zm8.077-2q0 .82-.302 1.555a3.8 3.8 0 0 1-.846 1.278.35.35 0 0 1-.378.041.32.32 0 0 1-.205-.312V9.389q0-.224.205-.313a.35.35 0 0 1 .378.041q.544.549.846 1.306T17.5 12M12 8.85 9.85 11H7v2h2.85L12 15.15z"
    />
  </>
)
export default VolumeDown
